import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class CoursioLogo extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M2.7,5c-0.4,0.6-1,0.9-1.7,0.9c-0.3,0-0.5-0.1-0.7-0.2C0.1,6.3,0,6.9,0,7.5c1,0,1.8,0.6,2,1.6v0c0,0,0,0,0,0
          c0.2,1-0.4,1.9-1.3,2.2c0.2,0.5,0.5,1.1,0.9,1.5c0.7-0.6,1.8-0.7,2.5-0.1c0.7,0.6,0.9,1.7,0.4,2.5c0.5,0.3,1.1,0.5,1.7,0.6
          C6.2,14.9,7,14.1,8,14.1c1,0,1.8,0.7,1.9,1.7c0.6-0.1,1.1-0.3,1.7-0.6c-0.5-0.8-0.4-1.9,0.4-2.5c0.8-0.6,1.8-0.6,2.5,0.1
          c0.3-0.5,0.7-1,0.9-1.5c-0.9-0.3-1.5-1.2-1.3-2.2c0.2-1,1-1.6,2-1.6c0-0.6-0.1-1.2-0.3-1.8c-0.2,0.1-0.5,0.2-0.7,0.2
          c-0.7,0-1.3-0.3-1.7-1c-0.5-0.8-0.3-1.9,0.5-2.5c-0.4-0.4-0.9-0.8-1.4-1.2c-0.3,0.6-1,1-1.7,1c-0.2,0-0.4,0-0.7-0.1
          C9.2,1.9,8.7,1,8.9,0.1C8.6,0,8.3,0,8,0C7.7,0,7.4,0,7.1,0C7.3,1,6.8,1.9,5.9,2.3C5.7,2.3,5.5,2.4,5.3,2.4C4.6,2.4,3.9,2,3.6,1.3
          C3.1,1.7,2.6,2,2.2,2.5C3,3,3.2,4.1,2.7,5z M8,3.4c2.5,0,4.6,2.1,4.6,4.6c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6
          C3.4,5.5,5.5,3.4,8,3.4z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Settings.js